import React from "react";
import PropTypes from 'prop-types';
import './PlayerTotalPoints.scss';

const PlayerTotalPoints = ({ points }) => {
  return (
    <div className="player-total-points">
      <span className="player-total-points__text">TOTAL POINTS</span>
      <span className="player-total-points__score">{points || '0'}</span>
    </div>
  );
};

PlayerTotalPoints.propTypes = {
  points: PropTypes.number
};

PlayerTotalPoints.defaultProps = {
  points: 0
};

export default PlayerTotalPoints;
